import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete\"><path d=\"M836.3 132.8H670.6c0-31.2-24.3-68.9-54.2-68.9H426.6c-30 0-54.2 37.7-54.2 68.9H196.2c-36.5 0-66.4 5.4-66.4 42.1v56.7h764.4V175c-0.1-36.7-21.3-42.2-57.9-42.2zM197.4 297.9v539.9c0 54.9 53.9 121.8 108.7 121.8h430.8c55 0 90.9-67 90.9-121.8V297.9H197.4z m181 551.1H312V371.3h66.4V849z m166.2 0h-66.4V371.3h66.4V849z m166.1 0h-66.4V371.3h66.4V849z m0 0\" p-id=\"17205\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/delete.svg
// module id = E9f3
// module chunks = 12